<template>
  <div class="quick-reply-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid">
          <div class="page-header qr-page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Quick Reply</h3>
                <p class="qr-page-subtitle">
                  Buat balasan siap pakai untuk chat WhatsApp.
                </p>
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-primary qr-add-btn" @click="openAdd">
                  <i class="fa fa-plus"></i> Tambah Quick Reply
                </button>
                <a
                  v-show="false"
                  ref="formBc"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                  @click="showBroadcast(true)"
                ></a>
                <a
                  v-show="false"
                  ref="formBcEdit"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                  @click="showBroadcast(false)"
                ></a>
              </div>
            </div>
          </div>

          <div class="qr-toolbar">
            <div class="qr-toolbar-grid">
              <div class="qr-search-field">
                <label for="qr-search-title">Cari judul</label>
                <input
                  id="qr-search-title"
                  v-model="serverParams.columnFilters.title"
                  type="text"
                  class="form-control qr-filter-input"
                  placeholder="Cari judul quick reply..."
                  @keyup.enter="searchData"
                />
              </div>
              <div class="qr-search-field">
                <label for="qr-search-message">Cari isi pesan</label>
                <input
                  id="qr-search-message"
                  v-model="serverParams.columnFilters.message"
                  type="text"
                  class="form-control qr-filter-input"
                  placeholder="Cari isi pesan..."
                  @keyup.enter="searchData"
                />
              </div>
              <div class="qr-search-field">
                <label for="qr-search-status">Status</label>
                <select
                  id="qr-search-status"
                  v-model="serverParams.columnFilters.is_publish"
                  class="form-control qr-filter-input"
                >
                  <option value="">Semua status</option>
                  <option value="publish">Published</option>
                  <option value="draft">Draft</option>
                </select>
              </div>
              <div class="qr-search-actions">
                <button type="button" class="btn btn-primary" @click="searchData">
                  <i class="fa fa-search"></i> Cari
                </button>
                <button type="button" class="btn btn-white" @click="resetFilter">
                  Reset
                </button>
              </div>
            </div>
          </div>

          <div v-if="selectedTable.length" class="qr-bulk-bar">
            <div class="qr-bulk-count">
              <span>{{ selectedTable.length }}</span>
              Quick Reply dipilih
            </div>
            <div class="qr-bulk-actions">
              <button type="button" class="btn btn-white btn-sm" :disabled="isLoading" @click="actionDraft">
                <i class="fa fa-save"></i> Jadikan Draft
              </button>
              <button type="button" class="btn btn-primary btn-sm" :disabled="isLoading" @click="actionPublish">
                <i class="fa fa-check"></i> Publish
              </button>
              <button type="button" class="btn btn-danger btn-sm" :disabled="isLoading" @click="actionDelete">
                <i class="fa fa-trash"></i> Hapus
              </button>
              <button type="button" class="btn btn-white btn-sm" @click="hideActions">
                Batal
              </button>
            </div>
          </div>

          <div class="qr-table-card">
            <div class="table-responsive">
              <table class="table qr-table mb-0">
                <thead>
                  <tr>
                    <th class="qr-check-col">
                      <input
                        v-model="selectAllTable"
                        type="checkbox"
                        :disabled="!rows.length || loading"
                        aria-label="Pilih semua Quick Reply di halaman ini"
                      />
                    </th>
                    <th>Judul Quick Reply</th>
                    <th>Preview isi pesan</th>
                    <th>Status</th>
                    <th>Terakhir diperbarui</th>
                    <th class="text-right">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="loading">
                    <tr>
                      <td colspan="6">
                        <Skeleton :count="4" />
                      </td>
                    </tr>
                  </template>

                  <template v-else-if="loadError">
                    <tr>
                      <td colspan="6">
                        <div class="qr-state-inline is-error">
                          <i class="fa fa-exclamation-triangle"></i>
                          <span>{{ loadError }}</span>
                          <button type="button" class="btn btn-white btn-sm" @click="loadItems">
                            Coba lagi
                          </button>
                        </div>
                      </td>
                    </tr>
                  </template>

                  <template v-else-if="rows.length">
                    <tr v-for="row in rows" :key="row.id">
                      <td class="qr-check-col">
                        <input
                          v-model="selectedTable"
                          type="checkbox"
                          :value="row"
                          :aria-label="'Pilih ' + titleOf(row)"
                        />
                      </td>
                      <td class="qr-title-cell">
                        <button
                          type="button"
                          class="qr-title-link"
                          :title="titleOf(row)"
                          @click="openDetail(row)"
                        >
                          {{ titleOf(row) }}
                        </button>
                        <span class="qr-row-meta">
                          <i :class="row.message_type == 'document' ? 'fa fa-file-o' : 'fa fa-comment-o'"></i>
                          {{ messageTypeLabel(row) }}
                          <template v-if="row.btn_main && row.btn_main.length">
                            · {{ row.btn_main.length }} tombol
                          </template>
                        </span>
                      </td>
                      <td class="qr-message-cell">
                        <p class="qr-message-preview">{{ previewOf(row) }}</p>
                        <button type="button" class="qr-detail-link" @click="openDetail(row)">
                          Lihat detail
                        </button>
                      </td>
                      <td>
                        <span class="qr-status-badge" :class="row.is_publish == 1 ? 'is-published' : 'is-draft'">
                          <i :class="row.is_publish == 1 ? 'fa fa-check-circle' : 'fa fa-save'"></i>
                          {{ row.is_publish == 1 ? "Published" : "Draft" }}
                        </span>
                      </td>
                      <td class="qr-date-cell">
                        <span :title="formatFullDate(row.update_datetime)">
                          {{ formatUpdated(row.update_datetime) }}
                        </span>
                      </td>
                      <td class="text-right">
                        <div class="dropdown action-label qr-action-dropdown">
                          <button
                            type="button"
                            class="btn btn-white btn-sm dropdown-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            :disabled="isLoading"
                          >
                            <i class="fa fa-ellipsis-h"></i> Aksi
                          </button>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a href="javascript:void(0)" class="dropdown-item" @click="openDetail(row)">
                              <i class="fa fa-eye text-info"></i> Lihat Detail
                            </a>
                            <a href="javascript:void(0)" class="dropdown-item" @click="detailData(row.id)">
                              <i class="fa fa-pencil text-success"></i> Edit
                            </a>
                            <a
                              v-if="row.is_publish == 1"
                              href="javascript:void(0)"
                              class="dropdown-item"
                              @click="draftData(row.id)"
                            >
                              <i class="fa fa-save text-warning"></i> Jadikan Draft
                            </a>
                            <a
                              v-else
                              href="javascript:void(0)"
                              class="dropdown-item"
                              @click="publishData(row.id)"
                            >
                              <i class="fa fa-check text-success"></i> Publish
                            </a>
                            <a href="javascript:void(0)" class="dropdown-item" @click="copyData(row.id)">
                              <i class="fa fa-copy text-info"></i> Duplikat
                            </a>
                            <div class="dropdown-divider"></div>
                            <a href="javascript:void(0)" class="dropdown-item text-danger" @click="deleteData(row.id)">
                              <i class="fa fa-trash"></i> Hapus
                            </a>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <div v-if="!loading && !loadError && !rows.length" class="qr-empty-state">
              <span class="qr-empty-icon">
                <i class="fa fa-comments-o"></i>
              </span>
              <h4>{{ hasActiveFilter ? "Quick Reply tidak ditemukan" : "Belum ada Quick Reply" }}</h4>
              <p v-if="hasActiveFilter">
                Coba ubah kata kunci atau reset filter untuk melihat data lainnya.
              </p>
              <p v-else>Buat balasan siap pakai agar tim dapat membalas chat lebih cepat.</p>
              <div class="qr-empty-actions">
                <button v-if="hasActiveFilter" type="button" class="btn btn-white" @click="resetFilter">
                  Reset Filter
                </button>
                <button type="button" class="btn btn-primary" @click="openAdd">
                  <i class="fa fa-plus"></i> Tambah Quick Reply
                </button>
              </div>
            </div>
          </div>

          <div v-if="totalRecords > 0" class="qr-pagination">
            <div class="qr-pagination-info">
              <span>Menampilkan {{ displayFrom }}-{{ displayTo }} dari {{ totalRecords }}</span>
              <select
                v-model.number="serverParams.perPage"
                class="form-control qr-per-page"
                :disabled="loading"
                @change="onPerPageChange"
              >
                <option :value="10">10 / halaman</option>
                <option :value="20">20 / halaman</option>
                <option :value="30">30 / halaman</option>
                <option :value="50">50 / halaman</option>
              </select>
            </div>
            <div class="qr-pagination-actions">
              <button
                type="button"
                class="btn btn-white btn-sm"
                :disabled="loading || currentPage <= 1"
                @click="onPageChange(currentPage - 1)"
              >
                <i class="fa fa-chevron-left"></i> Sebelumnya
              </button>
              <span class="qr-page-label">Halaman {{ currentPage }} dari {{ maxPage }}</span>
              <button
                type="button"
                class="btn btn-white btn-sm"
                :disabled="loading || currentPage >= maxPage"
                @click="onPageChange(currentPage + 1)"
              >
                Selanjutnya <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form-data :searchData="searchData" />

    <div v-if="showDetail && detailRow" class="qr-detail-overlay" @click.self="closeDetail">
      <div class="qr-detail-card" role="dialog" aria-modal="true">
        <div class="qr-detail-head">
          <div>
            <span class="qr-status-badge" :class="detailRow.is_publish == 1 ? 'is-published' : 'is-draft'">
              {{ detailRow.is_publish == 1 ? "Published" : "Draft" }}
            </span>
            <h5>{{ titleOf(detailRow) }}</h5>
            <p>{{ formatFullDate(detailRow.update_datetime) }}</p>
          </div>
          <button type="button" class="qr-detail-close" aria-label="Tutup" @click="closeDetail">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="qr-detail-body">
          <div v-if="detailRow.message_type == 'image' && detailRow.image_url" class="qr-detail-media">
            <img :src="detailRow.image_url" alt="Lampiran Quick Reply" />
          </div>
          <div v-else-if="detailRow.message_type == 'document' && detailRow.image_url" class="qr-detail-media">
            <a :href="detailRow.image_url" target="_blank" rel="noopener noreferrer">
              <i class="fa fa-file"></i> Lihat lampiran
            </a>
          </div>

          <p class="qr-detail-message">{{ detailRow.message || "-" }}</p>
          <p v-if="detailRow.footer_message" class="qr-detail-footer">
            {{ detailRow.footer_message }}
          </p>

          <div v-if="detailRow.btn_main && detailRow.btn_main.length" class="qr-detail-buttons">
            <strong>Tombol terkait</strong>
            <span v-for="(button, index) in detailRow.btn_main" :key="index">
              {{ button.button_text }}
            </span>
          </div>
        </div>

        <div class="qr-detail-foot">
          <button type="button" class="btn btn-white" @click="closeDetail">Tutup</button>
          <button type="button" class="btn btn-primary" @click="editFromDetail">
            <i class="fa fa-pencil"></i> Edit Quick Reply
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { timeAgo, formatLocalDate } from "@/utils/helper";
import FormData from "./form.vue";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";

function emptyForm() {
  return {
    header: {
      id: "",
      title: "",
      license_id: "",
      message: "",
      trigger_on: "all",
      trigger_on_some_type: "any",
      frequency_per_person: 15,
      is_enable_away_message: 0,
      is_enable_away_message_status: false,
      message_away: "",
      footer_message: "",
      footer_message_status: false,
      is_enable_attach_file: false,
      is_custom_url: false,
      image_url: "",
      message_type: "text",
      button_type: "text_reply"
    },
    detail_button: Array.from({ length: 10 }, () => ({
      auto_reply_button_id: ""
    }))
  };
}

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    FormData
  },
  data() {
    return {
      selectedTable: [],
      isLoading: false,
      loading: false,
      loadError: "",
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      showDetail: false,
      detailRow: null,
      requestSequence: 0,
      serverParams: {
        columnFilters: {
          title: "",
          message: "",
          is_publish: ""
        },
        page: 1,
        perPage: 20
      }
    };
  },
  computed: {
    selectAllTable: {
      get() {
        return this.rows.length > 0 && this.selectedTable.length === this.rows.length;
      },
      set(value) {
        this.selectedTable = value ? this.rows.slice() : [];
      }
    },
    maxPage() {
      return Math.max(
        1,
        Math.ceil(this.totalRecords / Number(this.serverParams.perPage || 20))
      );
    },
    displayFrom() {
      if (!this.totalRecords || !this.rows.length) {
        return 0;
      }
      return (
        (this.currentPage - 1) * Number(this.serverParams.perPage || 20) + 1
      );
    },
    displayTo() {
      if (!this.totalRecords || !this.rows.length) {
        return 0;
      }
      return (
        (this.currentPage - 1) * Number(this.serverParams.perPage || 20) +
        this.rows.length
      );
    },
    hasActiveFilter() {
      const filters = this.serverParams.columnFilters || {};
      return !!(
        String(filters.title || "").trim() ||
        String(filters.message || "").trim() ||
        String(filters.is_publish || "").trim()
      );
    }
  },
  created() {
    this.loadItems();
  },
  methods: {
    titleOf(row) {
      const title = String((row && row.title) || "").trim();
      if (title) {
        return title;
      }
      const message = String((row && row.message) || "").trim();
      return message ? message.slice(0, 60) : "Tanpa judul";
    },
    previewOf(row) {
      const message = String((row && row.message) || "").trim();
      return message || "Belum ada isi pesan.";
    },
    messageTypeLabel(row) {
      if (row.message_type == "image") {
        return "Gambar";
      }
      if (row.message_type == "document") {
        return "Dokumen";
      }
      return "Teks";
    },
    formatUpdated(value) {
      if (!value) {
        return "-";
      }
      return timeAgo(value);
    },
    formatFullDate(value) {
      if (!value) {
        return "-";
      }
      return formatLocalDate(value);
    },
    extractError(error, fallback) {
      if (error && error.message) {
        return String(error.message).replace(/<br\s*\/?>/gi, " ");
      }
      if (
        error &&
        error.response &&
        error.response.data &&
        (error.response.data.msg || error.response.data.message)
      ) {
        return String(
          error.response.data.msg || error.response.data.message
        ).replace(/<br\s*\/?>/gi, " ");
      }
      return fallback;
    },
    async loadItems() {
      const requestId = ++this.requestSequence;
      this.loading = true;
      this.loadError = "";

      const pageNumber = Math.max(1, Number(this.serverParams.page) || 1);
      const perPage = Math.max(1, Number(this.serverParams.perPage) || 20);
      const offset = (pageNumber - 1) * perPage;

      try {
        const response = await this.$store.dispatch(
          "automation/listQuickReply",
          {
            columnFilters: this.serverParams.columnFilters,
            page: offset,
            perPage: perPage
          }
        );

        if (requestId !== this.requestSequence) {
          return;
        }

        const payload = response && response.data ? response.data : {};
        this.currentPage = pageNumber;
        this.totalRecords = Number(payload.totalRecords) || 0;
        this.rows = Array.isArray(payload.data) ? payload.data : [];
      } catch (error) {
        if (requestId !== this.requestSequence) {
          return;
        }
        this.rows = [];
        this.totalRecords = 0;
        this.loadError = this.extractError(
          error,
          "Gagal memuat Quick Reply. Silakan coba lagi."
        );
      } finally {
        if (requestId === this.requestSequence) {
          this.loading = false;
        }
      }
    },
    searchData() {
      this.serverParams.page = 1;
      this.currentPage = 1;
      this.selectedTable = [];
      this.loadItems();
    },
    resetFilter() {
      this.serverParams.columnFilters = {
        title: "",
        message: "",
        is_publish: ""
      };
      this.searchData();
    },
    onPageChange(page) {
      const target = Math.min(Math.max(1, Number(page) || 1), this.maxPage);
      if (target === this.currentPage) {
        return;
      }
      this.serverParams.page = target;
      this.currentPage = target;
      this.selectedTable = [];
      this.loadItems();
    },
    onPerPageChange() {
      this.serverParams.page = 1;
      this.currentPage = 1;
      this.selectedTable = [];
      this.loadItems();
    },
    hideActions() {
      this.selectedTable = [];
    },
    openDetail(row) {
      this.detailRow = row;
      this.showDetail = true;
    },
    closeDetail() {
      this.showDetail = false;
      this.detailRow = null;
    },
    editFromDetail() {
      if (!this.detailRow) {
        return;
      }
      const id = this.detailRow.id;
      this.closeDetail();
      this.detailData(id);
    },
    openAdd() {
      if (this.$refs.formBc) {
        this.$refs.formBc.click();
      }
    },
    async detailData(id) {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.$store.dispatch("automation/setIsShowForm", false);

      try {
        const response = await this.$store.dispatch(
          "automation/detailQuickReplyForEdit",
          { id: id }
        );
        const data = response && response.data ? response.data : null;

        if (!data) {
          throw new Error("Data Quick Reply tidak ditemukan.");
        }

        data.header.is_custom_url = false;
        data.header.is_enable_attach_file = false;
        if (data.header.image_url != "") {
          data.header.is_enable_attach_file = true;
        }

        await this.$store.dispatch("automation/actFormParamQRSt", data);
        await this.$store.dispatch("automation/setIsShowForm", true);

        if (this.$refs.formBcEdit) {
          this.$refs.formBcEdit.click();
        }
      } catch (error) {
        this.$fire({
          title: "Gagal",
          text: this.extractError(error, "Gagal memuat detail Quick Reply."),
          type: "error",
          timer: 2500
        });
      } finally {
        this.isLoading = false;
      }
    },
    async copyData(id) {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.$store.dispatch("automation/setIsShowForm", false);

      try {
        const response = await this.$store.dispatch(
          "automation/detailQuickReplyForEdit",
          { id: id }
        );
        const data = response && response.data ? response.data : null;

        if (!data) {
          throw new Error("Data Quick Reply tidak ditemukan.");
        }

        data.header.copy = true;
        await this.$store.dispatch("automation/actFormParamQRSt", data);
        await this.$store.dispatch("automation/setIsShowForm", true);

        if (this.$refs.formBcEdit) {
          this.$refs.formBcEdit.click();
        }
      } catch (error) {
        this.$fire({
          title: "Gagal",
          text: this.extractError(error, "Gagal menduplikasi Quick Reply."),
          type: "error",
          timer: 2500
        });
      } finally {
        this.isLoading = false;
      }
    },
    async updateSingleStatus(id, action, successText) {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      try {
        const response = await this.$store.dispatch(action, { id: id });
        this.$fire({
          title: "Berhasil",
          text: (response && response.msg) || successText,
          type: "success",
          timer: 2000
        });
        await this.loadItems();
      } catch (error) {
        this.$fire({
          title: "Gagal",
          text: this.extractError(error, "Status Quick Reply gagal diubah."),
          type: "error",
          timer: 2500
        });
      } finally {
        this.isLoading = false;
      }
    },
    draftData(id) {
      this.updateSingleStatus(
        id,
        "automation/updateQuickReplyDraft",
        "Quick Reply berhasil dijadikan draft."
      );
    },
    publishData(id) {
      this.updateSingleStatus(
        id,
        "automation/updateQuickReplyPublish",
        "Quick Reply berhasil dipublish."
      );
    },
    deleteData(id) {
      if (this.isLoading) {
        return;
      }

      this.$fire({
        title: "Hapus Quick Reply?",
        text: "Data yang dihapus tidak dapat dikembalikan.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Hapus",
        denyButtonText: "Batal"
      }).then(async result => {
        if (result.value != true) {
          return;
        }

        this.isLoading = true;
        try {
          const response = await this.$store.dispatch(
            "automation/deleteQuickReply",
            { id: id }
          );
          this.$fire({
            title: "Berhasil",
            text: (response && response.msg) || "Quick Reply berhasil dihapus.",
            type: "success",
            timer: 2000
          });
          await this.loadItems();
        } catch (error) {
          this.$fire({
            title: "Gagal",
            text: this.extractError(error, "Quick Reply gagal dihapus."),
            type: "error",
            timer: 2500
          });
        } finally {
          this.isLoading = false;
        }
      });
    },
    bulkAction(action, successText, confirmText) {
      if (!this.selectedTable.length || this.isLoading) {
        return;
      }

      this.$fire({
        title: confirmText,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Lanjutkan",
        denyButtonText: "Batal"
      }).then(async result => {
        if (result.value != true) {
          return;
        }

        this.isLoading = true;
        try {
          const response = await this.$store.dispatch(action, {
            id: this.selectedTable
          });
          this.$fire({
            title: "Berhasil",
            text: (response && response.msg) || successText,
            type: "success",
            timer: 2000
          });
          this.selectedTable = [];
          await this.loadItems();
        } catch (error) {
          this.$fire({
            title: "Gagal",
            text: this.extractError(error, "Aksi gagal diproses."),
            type: "error",
            timer: 2500
          });
        } finally {
          this.isLoading = false;
        }
      });
    },
    actionDraft() {
      this.bulkAction(
        "automation/actionDraftQuickReply",
        "Quick Reply terpilih berhasil dijadikan draft.",
        "Jadikan draft " + this.selectedTable.length + " Quick Reply?"
      );
    },
    actionPublish() {
      this.bulkAction(
        "automation/actionPublishQuickReply",
        "Quick Reply terpilih berhasil dipublish.",
        "Publish " + this.selectedTable.length + " Quick Reply?"
      );
    },
    actionDelete() {
      this.bulkAction(
        "automation/actionDeleteQuickReply",
        "Quick Reply terpilih berhasil dihapus.",
        "Hapus " + this.selectedTable.length + " Quick Reply?"
      );
    },
    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("automation/setIsShowForm", false);
        this.selectedTable = [];
        this.$store.dispatch("automation/actFormParamQRSt", emptyForm());
        setTimeout(() => {
          this.$store.dispatch("automation/setIsShowForm", true);
        }, 100);
      }
    }
  },
  name: "quickReplyList"
};
</script>

<style scoped>
.quick-reply-page /deep/ .page-wrapper {
  background: #f8fafc;
}

.qr-page-header {
  margin-bottom: 22px;
}

.qr-page-subtitle {
  margin: 6px 0 0;
  color: #667085;
  font-size: 14px;
}

.qr-add-btn {
  height: 42px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}

.qr-toolbar {
  margin-bottom: 16px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 13px;
}

.qr-toolbar-grid {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) minmax(220px, 1.4fr) 150px auto;
  align-items: end;
  gap: 12px;
}

.qr-search-field label {
  display: block;
  margin-bottom: 6px;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
}

.qr-filter-input {
  height: 38px;
  border-color: #d0d5dd;
  border-radius: 8px;
  font-size: 12px;
}

.qr-filter-input:focus {
  border-color: #f99a43;
  box-shadow: 0 0 0 3px rgba(249, 154, 67, 0.12);
}

.qr-search-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.qr-search-actions .btn {
  height: 38px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.qr-bulk-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid #ffe1bd;
  border-radius: 10px;
}

.qr-bulk-count {
  color: #344054;
  font-size: 13px;
  font-weight: 600;
}

.qr-bulk-count span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  margin-right: 6px;
  padding: 0 7px;
  color: #b45309;
  background: #fff7e8;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.qr-bulk-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}

.qr-bulk-actions .btn {
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
}

.qr-table-card {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
}

.qr-table thead th {
  padding: 13px 14px;
  color: #667085;
  background: #fbfcfe;
  border-bottom: 1px solid #eef2f6;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
}

.qr-table tbody td {
  padding: 14px;
  color: #344054;
  border-top: 1px solid #f2f5f8;
  font-size: 13px;
  vertical-align: middle;
}

.qr-table tbody tr:hover {
  background: #fffdf9;
}

.qr-check-col {
  width: 42px;
  text-align: center;
}

.qr-title-cell {
  min-width: 210px;
  max-width: 280px;
}

.qr-title-link {
  display: block;
  max-width: 100%;
  padding: 0;
  overflow: hidden;
  color: #172033;
  background: transparent;
  border: 0;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qr-title-link:hover {
  color: #b45309;
}

.qr-row-meta {
  display: block;
  margin-top: 4px;
  color: #98a2b3;
  font-size: 10px;
}

.qr-message-cell {
  min-width: 260px;
  max-width: 460px;
}

.qr-message-preview {
  display: -webkit-box;
  max-height: 42px;
  margin: 0;
  overflow: hidden;
  color: #526071;
  font-size: 12px;
  line-height: 1.65;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.qr-detail-link {
  margin-top: 4px;
  padding: 0;
  color: #b45309;
  background: transparent;
  border: 0;
  font-size: 11px;
  font-weight: 600;
}

.qr-detail-link:hover {
  text-decoration: underline;
}

.qr-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.qr-status-badge.is-published {
  color: #067647;
  background: #ecfdf3;
}

.qr-status-badge.is-draft {
  color: #b54708;
  background: #fffaeb;
}

.qr-date-cell {
  color: #667085;
  font-size: 12px;
  white-space: nowrap;
}

.qr-action-dropdown .btn {
  height: 32px;
  padding: 0 10px;
  border-color: #d0d5dd;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
}

.qr-state-inline {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  color: #667085;
  font-size: 12px;
}

.qr-state-inline.is-error {
  color: #b42318;
}

.qr-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 20px;
  text-align: center;
}

.qr-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  margin-bottom: 14px;
  color: #b45309;
  background: #fff7e8;
  border-radius: 15px;
  font-size: 24px;
}

.qr-empty-state h4 {
  margin: 0 0 6px;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
}

.qr-empty-state p {
  max-width: 420px;
  margin: 0 0 16px;
  color: #667085;
  font-size: 13px;
  line-height: 1.6;
}

.qr-empty-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.qr-empty-actions .btn {
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.qr-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
}

.qr-pagination-info,
.qr-pagination-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.qr-pagination-info {
  color: #667085;
  font-size: 12px;
}

.qr-per-page {
  width: 135px;
  height: 34px;
  border-color: #d0d5dd;
  border-radius: 7px;
  font-size: 12px;
}

.qr-pagination-actions .btn {
  height: 34px;
  border-color: #d0d5dd;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
}

.qr-page-label {
  color: #667085;
  font-size: 12px;
}

.qr-detail-overlay {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  background: rgba(15, 23, 42, 0.48);
}

.qr-detail-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 620px;
  max-height: calc(100vh - 36px);
  overflow: hidden;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
}

.qr-detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 20px 22px 14px;
  border-bottom: 1px solid #eef2f7;
}

.qr-detail-head h5 {
  margin: 8px 0 3px;
  color: #172033;
  font-size: 17px;
  font-weight: 700;
}

.qr-detail-head p {
  margin: 0;
  color: #98a2b3;
  font-size: 11px;
}

.qr-detail-close {
  flex: 0 0 auto;
  padding: 0;
  color: #667085;
  background: transparent;
  border: 0;
  font-size: 18px;
}

.qr-detail-body {
  padding: 18px 22px;
  overflow-y: auto;
}

.qr-detail-message {
  margin: 0;
  color: #344054;
  font-size: 13px;
  line-height: 1.75;
  white-space: pre-line;
}

.qr-detail-footer {
  margin: 12px 0 0;
  color: #98a2b3;
  font-size: 11px;
}

.qr-detail-media {
  margin-bottom: 14px;
}

.qr-detail-media img {
  max-width: 100%;
  max-height: 260px;
  border: 1px solid #e8edf3;
  border-radius: 10px;
}

.qr-detail-media a {
  color: #b45309;
  font-size: 12px;
  font-weight: 600;
}

.qr-detail-buttons {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #eef2f7;
}

.qr-detail-buttons strong {
  margin-bottom: 2px;
  color: #344054;
  font-size: 12px;
}

.qr-detail-buttons span {
  padding: 6px 9px;
  color: #526071;
  background: #f8fafc;
  border: 1px solid #e8edf3;
  border-radius: 7px;
  font-size: 12px;
}

.qr-detail-foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 13px 22px;
  border-top: 1px solid #eef2f7;
}

.qr-detail-foot .btn {
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

@media (max-width: 991.98px) {
  .qr-toolbar-grid {
    grid-template-columns: 1fr 1fr;
  }

  .qr-search-actions {
    grid-column: 1 / -1;
  }
}

@media (max-width: 767.98px) {
  .qr-toolbar-grid {
    grid-template-columns: 1fr;
  }

  .qr-search-actions {
    grid-column: auto;
  }

  .qr-bulk-bar,
  .qr-pagination {
    align-items: stretch;
    flex-direction: column;
  }

  .qr-pagination-info,
  .qr-pagination-actions {
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/automation/quickReply/list.vue